import type { UserId } from "@inrev/common";

export const trailing90DayGwpQueryKey = (underwriterUserId?: UserId) =>
	underwriterUserId
		? (["dashboard", "trailing-90-day-gwp", underwriterUserId] as const)
		: (["dashboard", "trailing-90-day-gwp"] as const);
